import {CardTypeEnum} from "../../../types/CardTypeEnum";
import {Button, Modal} from "antd";
import React, {useEffect} from "react";


function IntentApp({providerName = ""}) {
    const [open, setOpen] = React.useState<boolean>(true);

    const setIntentApp = () => {
        setTimeout(() => {
            handlePayment(providerName);
        }, 2000);
    };

    const clickModal = () => {
        setOpen(false);
    }

    useEffect(() => {
        if (open) {
            setIntentApp();
        }
    }, []);

    const triggerLaunch = (url: string) => {
        window.location.href = url;

        const a = document.createElement('a');
        a.href = url;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const callEasypaisa = (isAndroid: boolean | true) => {
        if (isAndroid) {
            window.location.href = 'intent://easypaisa.onelink.me/miniapp#Intent;scheme=https;package=pk.com.telenor.phoenix;end';
        } else {
            const url = 'easypaisa://';
            triggerLaunch(url);
        }
    };

    const callJazzcash = (isAndroid: boolean | true) => {
        if (isAndroid) {
            window.location.href = 'intent://deeplink#Intent;scheme=jazzcash;package=com.techlogix.mobilinkcustomer;end';
        } else {
            const url = 'jazzcash://';
            triggerLaunch(url);
        }
    };

    const handlePayment = (providerName: string | string[]) => {
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = /android/.test(ua);
        if (providerName === CardTypeEnum.EasyPaisa) {
            console.log('[IntentApp] providerName : Easypaisa isAndroid :', isAndroid)
            callEasypaisa(isAndroid);
        }
        if (providerName === CardTypeEnum.JazzCash || providerName === CardTypeEnum.JazzCashV2) {
            callJazzcash(isAndroid);
            console.log('[IntentApp] providerName : Jazzcash isAndroid :', isAndroid)
        }
    };

    return (
        <>
            <Modal
                title={" "}
                footer={
                    <Button type="primary" onClick={clickModal}>
                        OK
                    </Button>
                }
                open={open}
                onCancel={() => setOpen(false)}
                width={500}
                bodyStyle={{
                    height: "200px"
                }}
            >
                <div style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#1B1B1B",
                    textAlign: "left"
                }}>
                    Please wait patiently.<br/>
                    You will be automatically redirected to the wallet app later,
                    or you can log in to the wallet app to pay by yourself.
                </div>
                <br/>
                <hr/>
                <br/>
                <div style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#878787",
                    textAlign: "right",
                    direction: "rtl"
                }}>
                    براہ کرم انتظار کریں۔ آپ کو جلد ہی والیٹ ایپ پر بھیج دیا جائے گا، یا آپ ادائیگی مکمل کرنے کے لیے
                    والیٹ ایپ میں لاگ ان کر سکتے ہیں
                </div>
            </Modal>
        </>
    )
}

export default IntentApp;
